import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

const PinVerificationModal = ({ show, onVerify, attempts, maxAttempts, onClose }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [localAttempts, setLocalAttempts] = useState(0);
  const { register, handleSubmit, formState: { errors }, reset, setFocus } = useForm();
  const pinInputRef = useRef(null);

  useEffect(() => {
    if (show) {
      reset();
      setErrorMessage('');
      setTimeout(() => {
        setFocus('pin');
      }, 100);
    } else {
      setErrorMessage('');
      setLocalAttempts(0);
    }
  }, [show, reset, setFocus]);

  useEffect(() => {
    setLocalAttempts(attempts);
  }, [attempts]);

  const onSubmit = async (data) => {
    setErrorMessage('');
    try {
      await onVerify(data.pin);
      reset();
      setErrorMessage('');
    } catch (error) {
      const errorMsg = error.message || 'PIN incorreto.';
      setErrorMessage(errorMsg);
      reset({ pin: '' });
      setTimeout(() => {
        setFocus('pin');
      }, 100);
    }
  };

  const remainingAttempts = maxAttempts - localAttempts;
  const isBlocked = localAttempts >= maxAttempts;

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      className="pin-verification-modal"
    >
      <Modal.Body className="p-4">
        <div className="text-center mb-4">
          <h4>Verificação de PIN</h4>
          <p className="text-muted">Digite seu PIN para continuar</p>
        </div>

        {isBlocked && (
          <Alert variant="danger" className="mb-3">
            <strong>Máximo de tentativas excedido!</strong> Você será desconectado.
          </Alert>
        )}

        {!isBlocked && localAttempts > 0 && remainingAttempts > 0 && (
          <Alert variant="warning" className="mb-3">
            Tentativas restantes: <strong>{remainingAttempts}</strong> de {maxAttempts}
          </Alert>
        )}

        {errorMessage && !isBlocked && (
          <Alert variant="danger" className="mb-3">
            {errorMessage}
          </Alert>
        )}

        <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off" data-form-type="other">
          <Form.Group controlId="pin" className="mb-3">
            <Form.Label>PIN</Form.Label>
            <Form.Control
              ref={pinInputRef}
              type="password"
              maxLength={4}
              placeholder="Digite seu PIN (4 dígitos)"
              autoComplete="one-time-code"
              data-form-type="other"
              data-lpignore="true"
              data-1p-ignore="true"
              data-bwignore="true"
              disabled={isBlocked}
              {...register('pin', {
                required: 'O PIN é obrigatório',
                minLength: {
                  value: 4,
                  message: 'O PIN deve conter 4 dígitos',
                },
                maxLength: {
                  value: 4,
                  message: 'O PIN deve conter 4 dígitos',
                },
                pattern: {
                  value: /^\d+$/,
                  message: 'O PIN deve conter apenas números',
                },
              })}
              isInvalid={!!errors.pin}
            />
            <Form.Control.Feedback type="invalid">
              {errors.pin && errors.pin.message}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={isBlocked}
          >
            {isBlocked ? 'Bloqueado' : 'Verificar PIN'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PinVerificationModal;

